import onReady from '../utils/onReady';
import $ from 'jquery';
import _ from 'underscore';
import bxSliderConstructor from "../vendor/jquery.bxslider";

/**
 * Boilerplate class demonstrating basic construction.
 * You can expand from here, or find verbose examples in example.js.
 *
 * @param {HTMLElement} container
 * @constructor
 */
class VerticalSlider {

    /**
     * The constructor is fired once the class is instantiated.
     *
     * @param {HTMLElement} container
     */
    constructor(container) {
        // Run initializing code once the DOM is ready.

        onReady(() => this.init(container));


        // You can put other initializer-code here if it isn't dependent on the DOM in any way.
    }


    sliderFiltering(slider) {
        let li_nav_items = $(".case-navigation li");
        let nav_items = $(".case-navigation li a");

        $('.case-navigation li:last-child').addClass('selected');

        nav_items.click(function (e) {
            e.preventDefault();

            li_nav_items.each(function (i) {
                $(this).removeClass('selected');
            });

            $(this).parent().addClass("selected");
            let filter = $(this).data('filter');
            let slider_items = [];

            $('.case').each(function (i) {
                if ($(this).data('sort') === filter) {
                    slider_items.push($(this));
                }
            });

            let slide_index = slider_items[0].data('index');
            slider.slick("slickGoTo", slide_index);
        });
    }

    /**
     * The actual initialization function, fired once the DOM is ready.
     *
     * @param {HTMLElement} container
     */
    init(container) {

        this.dom = {
            container // ES6 allows this syntax instead of writing "container: container"
        };

        /*let bxSlider = new bxSliderConstructor($);

        const slider = $(this.dom.container).bxSlider({
            auto: 0,
            touchEnabled: true,
            swipeThreshold: 30,
            slideMargin: 0,
            preloadImages: "all",
            responsive: true,
            mode: "vertical",
            pager: false,
            controls: false,
            infiniteLoop: false,
            onSlideAfter: function (currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
                $('.active-slide').removeClass('active-slide');
                $('.vertical-slider--initialized .case').eq(currentSlideHtmlObject).addClass('active-slide');
            },
            onSliderLoad: function () {
                $('.vertical-slider--initialized .case').eq(0).addClass('active-slide')
            },
        });*/


        const sliderElement = this.dom.container;
        const getCurrentSlideFromLocalStorage = localStorage.getItem("currentSlide");

        if ($(window).width() > 768) {
            const slider = $(sliderElement);
            slider.on("afterChange", function (slick, currentSlide){
                localStorage.setItem("currentSlide", currentSlide.currentSlide);
            }).slick({
                infinite: false,
                speed: 300,
                slidesToScroll: 1,
                vertical: true,
                verticalSwiping: true,
                useTransform: true,
                cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
                adaptiveHeight: true,
                init: function () {
                    console.log("set active");
                    $('.slick-current').addClass('active-slide');
                },
                onBeforeChange: function (slick, currentSlide) {
                    console.log("before change");
                    $(".slick-slide").removeClass('active-slide');
                    $('.slick-current').addClass('active-slide');
                    // $('.active-slide').removeClass('active-slide');
                    // $('.vertical-slider--initialized .case').eq(currentSlideHtmlObject).addClass('active-slide');
                }
            });

            if(getCurrentSlideFromLocalStorage) {
                slider.slick("slickGoTo", parseInt(getCurrentSlideFromLocalStorage));
                localStorage.removeItem("currentSlideItem");
            }

            $("body").on('mousewheel', _.debounce(function (e) {
                if (typeof e.originalEvent.detail === 'number' && e.originalEvent.detail !== 0) {
                    if (e.originalEvent.detail > 1) {
                        //slider.goToNextSlide();
                        slider.slick("slickNext");
                    } else if (e.originalEvent.detail < 1) {
                        slider.slick("slickPrev");
                        //slider.goToPrevSlide();
                    }
                } else if (typeof e.originalEvent.wheelDelta === 'number') {
                    if (e.originalEvent.wheelDelta < 1) {
                        //slider.goToNextSlide();
                        slider.slick("slickNext");
                    } else if (e.originalEvent.wheelDelta > 1) {
                        slider.slick("slickPrev");
                        //slider.goToPrevSlide();
                    }
                }
            }, 100));


            $("body").on('wheel', _.debounce(function (e) {
                let deltaY = e.originalEvent.deltaY;
                if (typeof e.originalEvent.detail === 'number' && e.originalEvent.detail !== 0) {
                    if (e.originalEvent.detail > 0.01) {
                        //slider.goToNextSlide();
                        slider.slick("slickNext");
                    } else if (e.originalEvent.detail < 0.01) {
                        //slider.goToPrevSlide();
                        slider.slick("slickPrev");
                    }
                } else if (typeof e.originalEvent.wheelDelta === 'number') {
                    if (e.originalEvent.wheelDelta < 0.01) {
                        //slider.goToNextSlide();
                        slider.slick("slickNext");
                    } else if (e.originalEvent.wheelDelta > 0.01) {
                        //slider.goToPrevSlide();
                        slider.slick("slickPrev");
                    }
                } else if (typeof e.originalEvent.detail === 'number') {
                    if (e.originalEvent.deltaY < 0.01) {
                        //slider.goToPrevSlide();
                        slider.slick("slickNext");
                    } else if (e.originalEvent.deltaY > 0.01) {
                        //slider.goToNextSlide();
                        slider.slick("slickPrev");
                    }
                }
            }, 100));


            this.sliderFiltering(slider);

        }

    }

}


export default VerticalSlider;